import * as React from 'react';
import { useContext } from 'react';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';

export type DegreesCollectionsContextType = {
  degrees?: CarouselCollection;
  degreeRecommendationsLoading?: boolean;
};

const DegreesCollectionsContext = React.createContext<DegreesCollectionsContextType | undefined>({
  degrees: undefined,
  degreeRecommendationsLoading: true,
});

export const useCollections = () => {
  const collections = useContext(DegreesCollectionsContext);

  return collections;
};

export default DegreesCollectionsContext;
